<template>
    <div>
    <TextBanner>
        Seit einem Jahr ist Block 4 auch für Touristen zugänglich. Eigentlich. Denn seit der Corona-Pandemie sind auch die Touren zum Erliegen gekommen.
    </TextBanner>
    
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/12_Tourismus_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/12_Tourismus_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>         
        </Fallback>

    </div>
</template>



<script>
    export default {
        name: 'Touristen',
        babylonState: {
            moveCamera: [-7.3, 1.55, 3.5, 14.5 ,0.4,0],    

            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,

                    Geo_Sperrzone: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_anim: false,

                    Geo_Neuer_Sarkophag_endpos_transparent: true,
                            /*visible: true,
                            position: [0,0,0],
                    },*/

                    Geo_Schienen_Sarkophag: true,
                    Geo_Schattenplane_NSC: true,

                    Geo_GrosserTurm_Gestaenge1: false,
                    Geo_GrosserTurm_Schlot1: false,
                    Geo_GrosserTurm_RoteStreifen1: false,
                    Geo_GrosserTurm_Schattenplane: false,

                    Geo_KleinerTurm_Geruest1: true,
                    Geo_KleinerTurm_Schlot1: true,
                    Geo_KleinerTurm_RoteStreifen1: true,
                    Geo_KleinerTurm_Schattenplane: true, 
                    
          

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            this.$audioController.initTrack('background', require('./../assets/audio/Geigerzaehler.mp3'), true, false),

            this.$babylonController.setClipping(0.3, 20000);
            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (3,30),
            this.$babylonController.zoomCamera(1.8)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
